'use client';

import type { UpdateCustomerInput } from '@/app/api/customer-session/customer/route';
import { swrMutationFetcher } from '@/utils/swr-utils';
import { Customer } from '@asurion-core/asp-core';
import { HTTPError } from '@sales-domain/http-errors';
import { useSWRConfig, type Key } from 'swr';
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation';

export function useUpdateAuthorizedCustomer({
  onError,
}: SWRMutationConfiguration<
  Customer,
  HTTPError,
  Key,
  UpdateCustomerInput
> = {}) {
  const { mutate } = useSWRConfig();
  const { trigger: updateCustomer, isMutating: isUpdatingCustomer } =
    useSWRMutation<Customer, HTTPError, Key, UpdateCustomerInput>(
      '/api/customer-session/customer',
      swrMutationFetcher,
      {
        populateCache: true,
        // Since the API already returns the updated customer,
        // we don't need to revalidate here.
        revalidate: false,
        onSuccess: () => {
          mutate('/api/customer-session');
        },
        onError,
        throwOnError: false,
      },
    );

  return { updateCustomer, isUpdatingCustomer };
}
